<template>
  <div class="recharge">
    <Breadcrumb></Breadcrumb>
    <div class="papage__style recharge-chunk">
      <div class="content__style">
        <div class="left__style-3iV1Zc">
          <div class="ant-tabs ant-tabs-top">
            <div style="margin: 0 0 29px 0" role="tablist" class="ant-tabs-nav">
              <el-menu
                :default-active="activeIndex"
                class="el-menu-demo"
                mode="horizontal"
                @select="handleSelectMenu"
              >
                <el-menu-item index="1">会员套餐</el-menu-item>
                <el-menu-item index="2">增值服务</el-menu-item>
              </el-menu>
            </div>
            <div v-if="activeIndex == '1'" class="ant-tabs-content-holder">
              <div class="ant-tabs-content ant-tabs-content-top">
                <div class="ant-tabs-tabpane ant-tabs-tabpane-active">
                  <div class="itembox__style-7qamrD">
                    <div
                      v-for="(record, index) in serviceList"
                      :key="index"
                      @click="handleSelectVipService(record, index)"
                      :class="{ activeItem__style: activeItem == index }"
                      class="item__style-25djUr"
                    >
                      <div class="name__style-1bU1sZ">{{ record.title }}</div>
                      <div class="price__style-1-uNnO">
                        ￥<span>{{ record.cost }}</span
                        >/{{ record.timeType == "01" ? "年" : "月" }}
                      </div>
                      <div class="text__style-2NNe8K">{{ record.desc }}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="activeIndex == '2'" class="ant-tabs-content-holder">
              <div class="ant-tabs-content ant-tabs-content-top">
                <div class="ant-tabs-tabpane ant-tabs-tabpane-active">
                  <div class="itembox__style-7qamrD">
                    <div
                      v-for="(record, index) in serviceListAdd"
                      :key="index"
                      @click="handleSelectAddService(record)"
                      :class="{
                        activeItem__style: activeItem == record.serviceItem,
                      }"
                      class="item__style-25djUr"
                    >
                      <div class="name__style-1bU1sZ">{{ record.title }}</div>
                      <div class="price__style-1-uNnO">
                        ￥<span>{{ record.price }}</span
                        >{{ record.unit }}
                      </div>
                    </div>
                    <div
                      @click="handleSelectDomain(record)"
                      :class="{
                        activeItem__style: activeItem == 'domain',
                      }"
                      class="item__style-25djUr"
                    >
                      <div class="name__style-1bU1sZ">独立域名</div>
                      <div class="price__style-1-uNnO">
                        ￥<span>{{ price }}</span
                        >/
                        {{ serviceListAdd[0].timeType == "01" ? "年" : "月" }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-if="activeIndex == '1'" class="numberForm__style-3ImAdE">
            <span style="margin-right: 10px"
              ><span style="color: red; margin-right: 3px">*</span>开通时长:
            </span>
            <el-input-number
              v-model="openYear1"
              @change="handleChangeYear1"
              :min="1"
              :max="10"
              label=""
            ></el-input-number>
            <div style="margin-left: 15px">
              {{ serviceList[0].timeType == "01" ? "年" : "月" }}
            </div>
          </div>
          <div v-if="activeIndex == '2'" class="numberForm__style-3ImAdE">
            <span v-if="activeItem != 'domain'" style="margin-right: 10px"
              ><span style="color: red; margin-right: 3px">*</span>开通时长:
            </span>
            <el-input-number
              v-if="activeItem != 'domain'"
              v-model="openYear2"
              @change="handleChangeYear2"
              :min="1"
              :max="10"
              label=""
            ></el-input-number>
            <div v-if="activeItem != 'domain'" style="margin-left: 15px">
              {{ serviceListAdd[0].timeType == "01" ? "年" : "月" }}
            </div>
            <span v-if="activeItem == 'domain'" style="margin-right: 10px"
              ><span style="color: red; margin-right: 3px">*</span>开通域名:
            </span>
            <el-input
              v-if="activeItem == 'domain'"
              style="width: 500px; padding-top: -10px; margin: 0 8px 0 0"
              placeholder="请输入域名"
              v-model="saveParams.busiDomain"
              size="small"
            />
          </div>
          <el-card
            style="margin: 29px 0 0 0;"
            v-if="
              activeIndex == '2' &&
                activeItem == 'domain' &&
                tableData.length > 0
            "
          >
            <div slot="header">域名绑定记录</div>
            <!-- 表格 -->
            <el-row
              style="
              background-color: white;
              padding: 10px 10px 10px 10px;
              margin-top: -4px;
              line-height: 1;
            "
            >
              <el-col :span="24">
                <template>
                  <el-table
                    v-loading="loading"
                    :data="tableData"
                    borderstyle="width: 100%"
                    border
                  >
                    <el-table-column
                      prop="createTime"
                      label="操作时间"
                      align="center"
                    >
                    </el-table-column>
                    <el-table-column
                      prop="nickName"
                      label="操作人"
                      align="center"
                    >
                      <template slot-scope="scope">
                        <span>{{
                          scope.row.nickName
                            ? scope.row.nickName
                            : scope.row.operNo
                        }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column
                      prop="busiDomain"
                      label="绑定域名"
                      align="center"
                    >
                    </el-table-column>
                    <el-table-column prop="status" label="状态" align="center">
                      <template slot-scope="scope">
                        <span>{{
                          dictMap["check_status"][scope.row.checkStatus]
                        }}</span>
                      </template>
                    </el-table-column>
                  </el-table>
                  <pagination
                    style="margin: 8px 0 0 0"
                    v-show="total > 0"
                    :total="total"
                    :page.sync="queryParams.pageNum"
                    :limit.sync="queryParams.pageSize"
                    @pagination="loadList"
                  />
                </template>
              </el-col>
            </el-row>
          </el-card>
          <div
            v-if="buyInfo.code != -1 && activeIndex == 1"
            class="moment__style-3x87uz"
          >
            完成支付后立马生效，有效期到{{
              buyInfo.expreTime.substring(0, 10)
            }}。
            <span v-if="buyInfo.leftCost != 0"
              >暂不支持到期前取消原套餐因服务未到期，可退{{
                buyInfo.leftCost
              }}元，本次需支付{{ buyInfo.needMoney }}元。</span
            >
          </div>
          <div
            v-if="buyInfo.code == -1 && activeIndex == 1"
            class="moment__style-3x87uz"
          >
            不允许降级购买，请重新选择
          </div>
          <div v-if="activeIndex == '3'" class="common-limit">
            <el-card style="margin: 0 0 12px 0">
              <el-form label-position="right" label-width="100px">
                <el-form-item label="支付类型：">
                  增值服务-绑定独立域名
                </el-form-item>
                <el-form-item label="绑定域名：" prop="busiDomain">
                </el-form-item>
                <el-form-item label="应付金额：" prop="amount">
                  <span style="color: #f05f6b;font-size:19px;font-weight:bold;"
                    >{{ price }}元</span
                  >
                </el-form-item>
              </el-form>
            </el-card>
          </div>
        </div>
        <div class="right__style">
          <div class="ant-tabs ant-tabs-top">
            <div role="tablist" class="ant-tabs-nav">
              <div class="ant-tabs-nav-wrap">
                <div
                  class="ant-tabs-nav-list"
                  style="transform: translate(0px, 0px)"
                >
                  <div class="ant-tabs-tab ant-tabs-tab-active">
                    <div
                      role="tab"
                      aria-selected="true"
                      class="ant-tabs-tab-btn"
                      tabindex="0"
                      id="rc-tabs-1-tab-balance"
                      aria-controls="rc-tabs-1-panel-balance"
                    >
                      余额支付
                    </div>
                  </div>
                  <div
                    class="ant-tabs-ink-bar ant-tabs-ink-bar-animated"
                    style="left: 0px; width: 56px"
                  ></div>
                </div>
              </div>
              <div
                class="ant-tabs-nav-operations ant-tabs-nav-operations-hidden"
              >
                <button
                  type="button"
                  class="ant-tabs-nav-more"
                  tabindex="-1"
                  aria-hidden="true"
                  aria-haspopup="listbox"
                  aria-controls="rc-tabs-1-more-popup"
                  id="rc-tabs-1-more"
                  aria-expanded="false"
                  style="visibility: hidden; order: 1"
                >
                  <span
                    role="img"
                    aria-label="ellipsis"
                    class="anticon anticon-ellipsis"
                    ><svg
                      viewBox="64 64 896 896"
                      focusable="false"
                      data-icon="ellipsis"
                      width="1em"
                      height="1em"
                      fill="currentColor"
                      aria-hidden="true"
                    >
                      <path
                        d="M176 511a56 56 0 10112 0 56 56 0 10-112 0zm280 0a56 56 0 10112 0 56 56 0 10-112 0zm280 0a56 56 0 10112 0 56 56 0 10-112 0z"
                      ></path></svg
                  ></span>
                </button>
              </div>
            </div>
            <div>
              <div class="ant-tabs-content ant-tabs-content-top">
                <div class="ant-tabs-tabpane ant-tabs-tabpane-active">
                  <div class="balance__style-3MtxIc">
                    <div class="money__style-3AKCfw">
                      <div>支付金额</div>
                      <div>￥{{ costPrice }}</div>
                    </div>
                    <div class="overage__style-1ogmdT">
                      <div>
                        余额<span>(￥{{ user.balance }})</span>
                      </div>
                    </div>
                    <div
                      v-if="costPrice > user.balance"
                      class="balanceError__style-3qUhnv"
                    >
                      余额不足，请先充值再支付！
                    </div>
                    <div class="payBtn__style-KFd9zi">
                      <div
                        @click="handleBuyService"
                        class="button__style-pnYPWX"
                      >
                        {{ costPrice > user.balance ? "充值" : "支付" }}
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  role="tabpanel"
                  tabindex="-1"
                  aria-hidden="true"
                  class="ant-tabs-tabpane"
                  id="rc-tabs-1-panel-alipay"
                  aria-labelledby="rc-tabs-1-tab-alipay"
                  style="display: none"
                ></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex"
import ElRow from "element-ui/packages/row/src/row"
import Breadcrumb from "@/components/common/Breadcrumb"
import { getUserProfile, saveUserFund } from "@/api/system/user"
import {
  getSeriveList,
  getAddServiceList,
  getVipServiceList,
  buyVipService,
  buyAddService,
  buyVipInfo,
} from "@/api/mine/service"
import { uploadFile } from "@/api/upload/upload"
import { getConfigKey } from "@/api/system/config"
import { getDomainList, addDomain } from "@/api/system/domain"

export default {
  components: { ElRow, Breadcrumb },
  data: function() {
    return {
      user: {},
      totalamount: "",
      input_czje: "",
      tranNo: "",
      //商家集合
      shopList: [{ value: "0", style: "-17px -10px" }],
      //单选
      radio: "", //支付方式
      radio1: "1000.00", //支付选择金额
      zfje: "", //最终显示支付金额
      czje: "", //自定义充值金额
      diaLog: {
        updateDialogFormVisible: false,
      },
      payData: {
        total_amount: "",
        subject: "",
      },
      activeName: "onLine",
      dataSource: [],
      chargeAmount: "", // 充值金额
      fileList: [], // 文件列表
      imgUrl: "", // 文件地址
      uploadFlag: true, //图片上传成功,
      queryParams: {
        pageSize: 10,
        pageNum: 1,
      },
      total: 0,
      isSubmit: false,
      finance: {
        alipayName: "",
        alipayNo: "",
        bankName: "",
        bankBranch: "",
        bankAccount: "",
        accountName: "",
      },
      activeItem: 0,
      activeIndex: "1",
      serviceList: [],
      serviceListAdd: [],
      vipPriceList: [],
      costPrice: 0,
      servicePrice: 0,
      openYear: 1,
      openYear1: 1,
      openYear2: 1,
      buyInfo: {
        leftCost: 0,
        needMoney: 0,
        expreTime: "",
      },
      saveParams: {
        busiDomain: "",
      },
      queryParams: {
        type: "0",
        pageNum: 1,
        pageSize: 10,
      },
      tableData: [],
    }
  },
  computed: {
    ...mapGetters(["dictData", "dictMap"]),
  },
  created() {
    //查询当前账户余额
    this.getUser()
    this.init() //初始化
    this.loadList()
    this.getConfigKey()
  },

  methods: {
    //查询当前账户余额
    getUser() {
      getUserProfile({}).then((response) => {
        this.user = response.user
        this.user.balance = this.user.balance.toFixed(2)
      })
    },
    loadList() {
      getDomainList(this.queryParams).then((response) => {
        this.tableData = response.rows
        this.total = response.total
        this.loading = false
      })
    },
    // 查询充值记录
    async getVipServiceList() {
      let result = await getVipServiceList()
      let serviceList = result
      serviceList.splice(0, 1)
      serviceList[0].title = "创业版(V1)"
      serviceList[0].desc = "适合初创公司"
      serviceList[1].title = "专业版(V2)"
      serviceList[1].desc = "适合发展期公司"
      serviceList[2].title = "企业版(V3)"
      serviceList[2].desc = "适合大型公司"
      this.serviceList = serviceList
      this.costPrice = serviceList[0].cost
      this.servicePrice = serviceList[0].cost
    },
    async getBuyInfo() {
      let result = await buyVipInfo({
        vipType: Number(this.activeItem) + 1,
        years: this.openYear1,
      })
      this.buyInfo = result.data
      if (this.buyInfo.code != -1 && this.activeIndex == 1) {
        this.costPrice = this.buyInfo.needMoney
      }
    },
    async getAddServiceList() {
      let result = await getAddServiceList()
      let serviceListAdd = result
      serviceListAdd.map((record) => {
        if (record.serviceItem == "ACCOUNT") {
          record.title = "子账号数量"
          record.unit =
            `/${record.serviceNum}个/` + (record.timeType == "01" ? "年" : "月")
        }
        if (record.serviceItem == "SHOP") {
          record.title = "店铺数量"
          record.unit =
            `/${record.serviceNum}个/` + (record.timeType == "01" ? "年" : "月")
        }
        if (record.serviceItem == "DESIGN") {
          record.title = "设计次数"
          record.unit =
            `/${record.serviceNum / 10000}万次/` +
            (record.timeType == "01" ? "年" : "月")
        }
        if (record.serviceItem == "MAP") {
          record.title = "图库容量"
          record.unit =
            `/${(record.serviceNum / 1024).toFixed(2)}G/` +
            (record.timeType == "01" ? "年" : "月")
        }
      })
      this.serviceListAdd = serviceListAdd
    },
    handleSelectVipService(record, index) {
      this.costPrice = record.cost * this.openYear1
      this.servicePrice = record.cost
      this.activeItem = index
      this.getBuyInfo()
    },
    handleSelectAddService(record) {
      this.costPrice = record.price * this.openYear2
      this.servicePrice = record.price
      this.activeItem = record.serviceItem
    },
    handleSelectDomain() {
      this.activeItem = "domain"
      this.costPrice = this.price
    },
    //充值
    async handleBuyService() {
      if (this.activeIndex == "2" && this.activeItem == "domain") {
        this.submitForm()
        return
      }
      if (this.costPrice > this.user.balance) {
        this.$router.push({
          path: "/system/account/recharge",
        })
        return
      }
      if (this.buyInfo.code == -1 && this.activeIndex == 1) {
        this.msgError("不允许降级购买，请重新选择")
        return
      }

      if (this.isSubmit) {
        return
      }
      this.isSubmit = true
      try {
        this.$confirm("请确认是否购买？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(async () => {
            let result = {}

            if (this.activeIndex == "1") {
              result = await buyVipService({
                vipType: (Number(this.activeItem) + 1).toString(),
                years: this.openYear1,
              })
            } else if (this.activeIndex == "2") {
              result = await buyAddService({
                serviceItem: this.activeItem,
                years: this.openYear2,
              })
            }

            if (result.code === 200) {
              // result = await getUserProfile({})
              // this.user = result.user
              this.events.$emit("updateUser")
              this.getBuyInfo()
              this.getUser()

              this.msgSuccess("充值成功")
              this.isSubmit = false
            } else {
              this.msgError("提交失败")
              this.isSubmit = false
            }
          })
          .catch(() => {
            this.isSubmit = false
          })
      } catch (error) {
        this.isSubmit = false
      } finally {
        // this.isSubmit = false
      }
    },
    handleChangeYear1() {
      this.costPrice = this.openYear1 * this.servicePrice
      if (this.activeIndex == 1) {
        this.getBuyInfo()
      }
    },
    handleChangeYear2() {
      this.costPrice = this.openYear2 * this.servicePrice
      if (this.activeIndex == 1) {
        this.getBuyInfo()
      }
    },

    /*初始化一些页面功能*/
    async init() {
      await this.getVipServiceList()
      await this.getAddServiceList()
      let type = this.$route.query.type
      let service = this.$route.query.service
      let vip = this.$route.query.vip

      if (type) {
        this.activeIndex = type
      }
      if (vip) {
        this.activeItem = vip
        this.handleSelectVipService(this.serviceList[vip], vip)
      }

      if (service) {
        this.activeItem = service
        for (let record of this.serviceListAdd) {
          if (record.serviceItem == service) {
            this.handleSelectAddService(record)
            break
          }
        }
      }
      this.getBuyInfo()
    },
    handleSelectMenu(index) {
      this.activeIndex = index
      if (index == "1") {
        this.costPrice = this.serviceList[0].cost * this.openYear1
        this.servicePrice = this.serviceList[0].cost
        this.activeItem = 0
      } else {
        this.activeItem = this.serviceListAdd[0].serviceItem
        this.costPrice = this.serviceListAdd[0].price * this.openYear2
        this.servicePrice = this.serviceListAdd[0].price
      }
    },
    getConfigKey() {
      var _self = this
      getConfigKey("domain.pay.amount")
        .then((res) => {
          if (res.code == 200) {
            this.price = res.msg
          }
        })
        .catch(function(error) {
          console.log(error)
        })
    },
    async submitForm() {
      try {
        if (this.isSubmit) {
          return
        }
        this.isSubmit = true
        if (this.saveParams.busiDomain == "") {
          this.msgError("请输入域名！")
          this.isSubmit = false
          return
        }

        let response = await addDomain(this.saveParams)
        if (response.code === 200) {
          this.saveParams.busiDomain = ""
          this.msgSuccess("申请已提交")
          this.loadList()
          this.getUser()
        } else {
          this.msgError("申请提交失败!")
        }
      } catch (error) {
        this.isSubmit = false
      } finally {
        this.isSubmit = false
      }
    },
    handleJump(path) {
      this.$router.push({ path: path })
    },
  },
}
</script>

<style scope>
@import "../../../assets/css/iconfont/iconfont.css";

.papage__style .ant-tabs-bar {
  border-bottom: 0;
}

.papage__style .ant-tabs-bar .ant-tabs-tab {
  font-size: 16px;
  color: #666666;
  padding: 12px 0;
  margin-right: 32px;
  margin-left: 10px;
  width: 64px;
  text-align: center;
}

.papage__style .ant-tabs-bar .ant-tabs-tab-active {
  font-size: 16px;
  color: #1a1a1a;
}

.papage__style .ant-tabs-bar .ant-tabs-ink-bar {
  width: 66px !important;
  height: 3px;
  background-color: #409eff;
}

.papage__style .content__style {
  width: 1200px;
  display: flex;
  justify-content: space-between;
  height: calc(100vh - 45px - 180px);
}

.papage__style .content__style .left__style-3iV1Zc {
  width: 840px;
  height: 100%;
  background: #fff;
  padding: 16px 20px 20px 20px;
  margin: 0 29px 0 0;
}

.papage__style .content__style .left__style-3iV1Zc .numberForm__style-3ImAdE {
  margin-top: 20px;
  display: flex;
  align-items: center;
  margin-left: 10px;
}

.papage__style
  .content__style
  .left__style-3iV1Zc
  .numberForm__style-3ImAdE
  .numPeriod__style-C3PH-4 {
  display: flex;
  align-items: center;
}

.papage__style
  .content__style
  .left__style-3iV1Zc
  .numberForm__style-3ImAdE
  .numPeriod__style-C3PH-4
  > div:nth-child(1) {
  margin: 0 10px;
}

.papage__style
  .content__style
  .left__style-3iV1Zc
  .numberForm__style-3ImAdE
  .numPeriod__style-C3PH-4
  > div:nth-child(3) {
  margin-left: 10px;
}

.papage__style .content__style .left__style-3iV1Zc .itembox__style-7qamrD {
  padding-bottom: 35px;
  margin-left: 10px;
  border-bottom: solid 1px #ebebeb;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-gap: 20px;
}

.papage__style
  .content__style
  .left__style-3iV1Zc
  .itembox__style-7qamrD
  .item__style-25djUr {
  height: 180px;
  background-color: #ffffff;
  border-radius: 4px;
  border: solid 1px #ebebeb;
  text-align: center;
  cursor: pointer;
  transition: margin-top 0.2s;
}

.papage__style
  .content__style
  .left__style-3iV1Zc
  .itembox__style-7qamrD
  .item__style-25djUr:hover {
  margin-top: -5px;
}

.papage__style
  .content__style
  .left__style-3iV1Zc
  .itembox__style-7qamrD
  .item__style-25djUr
  .name__style-1bU1sZ {
  margin-top: 36px;
  font-family: MicrosoftYaHei;
  font-size: 16px;
  font-weight: normal;
  font-style: italic;
  font-stretch: normal;
  line-height: 16px;
  letter-spacing: 1px;
}

.papage__style
  .content__style
  .left__style-3iV1Zc
  .itembox__style-7qamrD
  .item__style-25djUr
  .price__style-1-uNnO {
  font-family: MicrosoftYaHeiLight;
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  line-height: 16px;
  letter-spacing: 1px;
  color: #666666;
  margin-top: 20px;
}

.papage__style
  .content__style
  .left__style-3iV1Zc
  .itembox__style-7qamrD
  .item__style-25djUr
  .price__style-1-uNnO
  > span {
  font-family: MicrosoftYaHei;
  font-size: 36px;
  line-height: 36px;
  font-weight: bold;
  letter-spacing: 0px;
  color: #409eff;
}

.papage__style
  .content__style
  .left__style-3iV1Zc
  .itembox__style-7qamrD
  .item__style-25djUr
  .cost__style-32PyKB {
  font-size: 14px;
  color: #999999;
  text-decoration: line-through;
}

.papage__style
  .content__style
  .left__style-3iV1Zc
  .itembox__style-7qamrD
  .item__style-25djUr
  .text__style-2NNe8K {
  margin-top: 22px;
  font-family: MicrosoftYaHei;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  line-height: 14px;
  letter-spacing: 0px;
  color: #666666;
}

.papage__style
  .content__style
  .left__style-3iV1Zc
  .itembox__style-7qamrD
  .activeItem__style {
  background-color: #e5ecff;
  border: solid 1px #409eff;
  background-image: url(data:image/png;base64,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);
  background-repeat: no-repeat;
  background-position: 100% 100%;
}

.papage__style
  .content__style
  .left__style-3iV1Zc
  .itembox__style-7qamrD
  .activeItem__style
  .price__style-1-uNnO {
  color: #409eff;
  font-weight: bold;
}

.papage__style
  .content__style
  .left__style-3iV1Zc
  .itembox__style-7qamrD
  .activeItem__style
  .name__style-1bU1sZ {
  color: #409eff;
}

.papage__style .content__style .left__style-3iV1Zc .addedbox__style-gtMOlJ {
  border-bottom: solid 1px #ebebeb;
  padding-bottom: 35px;
  margin-left: 10px;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-gap: 20px;
}

.papage__style .content__style .left__style-3iV1Zc .promotion__style-rblWuc {
  position: relative;
}

.papage__style
  .content__style
  .left__style-3iV1Zc
  .promotion__style-rblWuc
  > div {
  position: absolute;
  top: -10px;
  right: -35px;
  width: 33px;
  height: 19px;
  background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACEAAAATCAYAAAAeVmTJAAABvElEQVRIicVWsUoDQRB9F9ImQgo1iCZF2gRsrAKCgiDxC7S0Sv4gX5A/MJWlfoCYTgshWATEIp2kMILGpAiEtNGTmd2727u93cMiyYOF25nZmTezs8M5vw+7AHAK4BpAHqvFCMClR4I22ysm4GGUkh/rIkDIp0wa56DDy6o//uCVBOewD+SqRqu0SeH2akChLhxMu8BmLawftICeIstV4ezfhp1MOnD79WSSsifcREsPRGzrTJBMcl5ua+Q52Ou5SEwivhIyK8522I4teUhmyNiTUTX5e9oVlY0gnsS0C/dxTxzIVvjbh6ES3D+Zsk5EPWuAsSfYwZPu1GgrSXHW0XPpjVD5o7CS8LMetLSm869DvQp6ARRMrRbJFjNrGCsJdjS+F5t5X29GCpatBPalZmBTbAjZzoVehcjeOCcYdMfDttXEhzIHuEp0BYU6vw738yawI3kE5kqQg7nSyZly/GCaiIHGGUsbbkaqUqkp9JZ+gI2EU2zAfb8KBAnXoT1RSmAxE3J1kM31J/r/YbUEUE9k10kAwDeROFonAfqfoJ44iVG+AbiT6xnAzzKZEAnqLBoGL8r6WmbQEAD8AdbEpIFCVA5EAAAAAElFTkSuQmCC);
}

.papage__style .content__style .right__style {
  height: 100%;
  width: 330px;
  background: #fff;
  padding: 16px 30px;
}

.papage__style .content__style .right__style .balance__style-3MtxIc > div {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.papage__style
  .content__style
  .right__style
  .balance__style-3MtxIc
  .money__style-3AKCfw {
  padding-bottom: 10px;
  margin-bottom: 20px;
  border-bottom: dashed 1px #ebebeb;
}

.papage__style
  .content__style
  .right__style
  .balance__style-3MtxIc
  .money__style-3AKCfw
  > div:nth-child(1) {
  font-size: 16px;
  color: #666666;
}

.papage__style
  .content__style
  .right__style
  .balance__style-3MtxIc
  .money__style-3AKCfw
  > div:nth-child(2) {
  font-size: 24px;
  color: #f94a51;
  font-weight: bold;
}

.papage__style
  .content__style
  .right__style
  .balance__style-3MtxIc
  .overage__style-1ogmdT,
.papage__style
  .content__style
  .right__style
  .balance__style-3MtxIc
  .gift__style-1QuHU6 {
  padding-bottom: 10px;
}

.papage__style
  .content__style
  .right__style
  .balance__style-3MtxIc
  .overage__style-1ogmdT
  > div:nth-child(1),
.papage__style
  .content__style
  .right__style
  .balance__style-3MtxIc
  .gift__style-1QuHU6
  > div:nth-child(1) {
  font-size: 14px;
  color: #666666;
}

.papage__style
  .content__style
  .right__style
  .balance__style-3MtxIc
  .overage__style-1ogmdT
  > div:nth-child(1)
  span,
.papage__style
  .content__style
  .right__style
  .balance__style-3MtxIc
  .gift__style-1QuHU6
  > div:nth-child(1)
  span {
  color: #999999;
}

.papage__style
  .content__style
  .right__style
  .balance__style-3MtxIc
  .overage__style-1ogmdT
  > div:nth-child(2),
.papage__style
  .content__style
  .right__style
  .balance__style-3MtxIc
  .gift__style-1QuHU6
  > div:nth-child(2) {
  font-size: 14px;
  color: #666666;
}

.papage__style
  .content__style
  .right__style
  .balance__style-3MtxIc
  .overage__style-1ogmdT
  > div:nth-child(2)
  span,
.papage__style
  .content__style
  .right__style
  .balance__style-3MtxIc
  .gift__style-1QuHU6
  > div:nth-child(2)
  span {
  color: #f94a51;
}

.papage__style
  .content__style
  .right__style
  .balance__style-3MtxIc
  .password__style-3bMTl3 {
  margin-top: 15px;
}

.papage__style
  .content__style
  .right__style
  .balance__style-3MtxIc
  .balanceError__style-3qUhnv {
  font-size: 12px;
  color: #f9535a;
  margin-top: 5px;
}

.papage__style
  .content__style
  .right__style
  .balance__style-3MtxIc
  .payBtn__style-KFd9zi {
  border-top: solid 1px #ebebeb;
  margin-top: 33px;
  padding-top: 35px;
}

.papage__style
  .content__style
  .right__style
  .balance__style-3MtxIc
  .payBtn__style-KFd9zi
  .button__style-pnYPWX {
  width: 110px;
  height: 32px;
  text-align: center;
  line-height: 32px;
  cursor: pointer;
  background-color: #409eff;
  border-radius: 4px;
  color: #fff;
  font-size: 14px;
  outline: none;
}

.papage__style
  .content__style
  .right__style
  .ali__style-2R5Jhr
  .paymoney__style-30Rz3h {
  display: flex;
  align-items: flex-end;
  line-height: 18px;
  color: #666666;
  margin-top: 22px;
  margin-bottom: 22px;
}

.papage__style
  .content__style
  .right__style
  .ali__style-2R5Jhr
  .paymoney__style-30Rz3h
  > div:nth-child(1) {
  position: relative;
  top: 3px;
  margin-right: 15px;
}

.papage__style
  .content__style
  .right__style
  .ali__style-2R5Jhr
  .paymoney__style-30Rz3h
  span {
  font-size: 24px;
  color: #f94a51;
  font-weight: bold;
}

.papage__style
  .content__style
  .right__style
  .ali__style-2R5Jhr
  .imgcode__style-2DavbU {
  width: 174px;
  height: 225px;
  padding: 5px;
  border: 1px solid #d6d6d6;
}

.papage__style
  .content__style
  .right__style
  .ali__style-2R5Jhr
  .imgcode__style-2DavbU
  .code__style {
  width: 100%;
}

.papage__style
  .content__style
  .right__style
  .ali__style-2R5Jhr
  .imgcode__style-2DavbU
  .text__style-2NNe8K {
  display: flex;
  align-items: center;
  justify-content: center;
}

.papage__style
  .content__style
  .right__style
  .ali__style-2R5Jhr
  .imgcode__style-2DavbU
  .text__style-2NNe8K
  > div:nth-child(1) {
  width: 25px;
  height: 25px;
  margin-right: 15px;
  background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAZCAYAAADE6YVjAAAAXklEQVRIiWP8t0f2PwN+wEhAHgTwmsFEhAEUAxYkA4hxMS6AS+9/uvlk1JLBZwkLhamKEACbPRrxJAEWQuUONcCwSF1gMDwjnhbBNlrUj2RLkBsSuIqXIdAkYmBgAADTVQoVw8fuVQAAAABJRU5ErkJggg==);
}

.papage__style
  .content__style
  .right__style
  .ali__style-2R5Jhr
  .imgcode__style-2DavbU
  .text__style-2NNe8K
  > div:nth-child(2) {
  font-size: 12px;
}

.papage__style
  .content__style
  .right__style
  .successPsy__style
  > div:nth-child(1) {
  display: flex;
  align-items: center;
  margin-top: 25px;
}

.papage__style
  .content__style
  .right__style
  .successPsy__style
  > div:nth-child(1)
  > div:nth-child(1) {
  width: 58px;
  height: 58px;
  background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADoAAAA6CAYAAADhu0ooAAAEjElEQVRogd2bTWwUZRiAn1lqsyiITfSAaQsrScEYjVEOoNGIEg4YYgBdAviTYrwYLhwsKgkgkoj83FFCm0AISBoSgqDhp0QEvKgnD9AE+ZHIRS9QtBDKmrf7DmxnZ2fmm/lmdtcn2Wy6u/O+77Odn2/f7xvn1vyFpEwH0KXPDwETNN0QcBP4AxjU59RoSSHwTOA14FVgNjAx4nY3gJ+AAeAE8LPNomyJPg68D3QDhZgx5AuZpw/hItAH7AT+TFpgLuH2U7UQKWpDAkk/ChrzouaYmiRYXNEHgU3AeWAF0JqkiBBaNYfk+lJzGxNHVI6734DVKQt6kVw9mnuW6cYmoo7KnbK8i5oiuX/UWpyo20YVzQPf6O6axpnalBatZZ/WFkoUUTkmDgNvNYCgl6LWFnrchonKcXFQr4mNitR2CBgfV1T2/15gbgNLuojsjqBjNkh0DbA8tdLsI7WuqRW1lujLwPomEaxkvdZehZ9oXnfZcXUpNRnjtPaqM7Gf6CfAtAYXCkJq/9j7vld0io4+mh0ZTHQGifZEvQA3OHmV9RWdrD+z/i90q1OVaHfYRbfJEJcP/ETfaTiPXA5n2RKcvu042zbBs8+YRnjvXih9fg6YYbXIpIjkqpVQXARtbTCtgPNpD7Q9YhL4CeD5StF5wZ+vk+RLL459vfUBKBg3GkaHsK7oHDsVWqCWpDAyAleMm4WjbjkdCL/QCI6BkqUSpa964a+/TaOOBhPR9opea/0Ik/y6F44ej1OeuHWI6PSmkPzuaJIMXe5/NB75PDz1JDz2aPwS0pcU2lti77Yd7Tgb18KkSeWC9u6H/QfMYmQjKUzMGUwZjMF5e2lZUnCc8oV9qUFbKTtJXNF4POzz/Sx5M5pstpLllDq5Y0zp5Cn/TcJk6yApjjmdvjPn2Ak4dMR/M5FdVqx+Pcp10r4krujVWJtKYb27assWF4+VjSL5fSqSwtUWnbyJh8qO9hgXzPeXlY/t66+npDAoM95Sy/VEoyM56654119WkPFpZ0f169lIDrln3ZLONMcnbDeun6RwlopfLwOJw4XJej+bjaRwkgrRY1ZCRpHNVhLXzRX9BThnJWyQbPaSvwO/4ukZ7bYW3pU9+O391+7ezVpS2KXnICrXGUlr8IL1TuCMLujshPODcPmK1dAh/Ktd+2t4Zq+v6XKXD62mOzdYfmRPnyuJT6d+M3CrHlVZZlhd7uEVvaxLXJqdzepSU1T4Qs9WzcoFdRiDn+iwLmAaaULREV2qN+x9o9YP7x+Az9KvyzobtPYqgjoMG4E9TSQp66A+r/VmkGhJd+FYzdSMGdBaS3FEhdvAG1YG/ekhtS0A/gnKEKU5JgFeB/obULJfawuUxGAt4LAuR5NFEHeS15eYO1pL0e8M64dJu7Okg4k5uli4XkjuV7SWmseklzh93dPA08AWPYazQnJt1dxnTHPGbWDf1BUs03UBU5rCtzWH5PpIcxuTdE39JR2JyGLhdfq3LS5pzILmSBQ7jfteZup0uns7SNTu4lDF7SDHbd8OkvUNPiJdeYOPPNK/wQf4Dx8sX19rFgrLAAAAAElFTkSuQmCC);
  margin-right: 10px;
}

.papage__style
  .content__style
  .right__style
  .successPsy__style
  > div:nth-child(1)
  > div:nth-child(2) {
  font-size: 24px;
  font-weight: bold;
  color: #f94a51;
}

.papage__style
  .content__style
  .right__style
  .successPsy__style
  > div:nth-child(2) {
  font-size: 16px;
  line-height: 24px;
  color: #666666;
  margin-top: 20px;
  margin-bottom: 28px;
}

.papage__style
  .content__style
  .right__style
  .successPsy__style
  > div:nth-child(3) {
  border-top: solid 1px #d9d9d9;
  padding-top: 29px;
}

.papage__style
  .content__style
  .right__style
  .successPsy__style
  > div:nth-child(3)
  .button__style-pnYPWX {
  width: 110px;
  height: 40px;
  text-align: center;
  line-height: 40px;
  cursor: pointer;
  background-color: #c38b3e;
  border-radius: 8px;
  color: #fff;
  font-size: 16px;
  outline: none;
}

.ant-tooltip-inner {
  font-size: 12px;
}

.domainPrompt__style-3_wZrr {
  margin-left: 15px;
  color: #999999;
}

.domainPrompt__style-3_wZrr a {
  color: #409eff;
}

.domainPrompt__style-3_wZrr a:hover {
  color: #060747;
}

.moment__style-3x87uz {
  color: #999999;
  margin: 16px 0 0 15px;
}
</style>
